import { render, staticRenderFns } from "./EventGeneralData.vue?vue&type=template&id=73b2b4fb&"
import script from "./EventGeneralData.vue?vue&type=script&lang=js&"
export * from "./EventGeneralData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports